<template>
  <div
    class="player-header"
    :class="{ dark }"
  >
    <div
      class="player-header-btn-left"
      @click="$emit('prev')"
    >
      <FlatIcon
        :size="34"
        name="prev"
      />
    </div>
    <div
      class="player-header-btn-center"
      @click="toggle"
    >
      <span class="btn-shadow">
        <FlatIcon
          :size="44"
          :name="playing ? 'stop' : 'play'"
        />
      </span>
    </div>
    <div
      class="player-header-btn-right"
      @click="$emit('next')"
    >
      <FlatIcon
        :size="34"
        name="next"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlayerHeader',
  props: {
    playing: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggle () {
      if (this.playing) {
        this.$emit('stop')
      } else {
        this.$emit('play')
      }
    }
  }
}
</script>

<style lang="scss">
.player-header {
  display: inline-flex;
  position: relative;
  align-items: center;
  flex-direction: row;
  padding: 10px;
  .player-header-btn-left,
  .player-header-btn-right,
  .player-header-btn-center {
    position: relative;
    border-radius: 50%;
    background: white;
    z-index: 2;
  }
  .player-header-btn-center {
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
  &:before {
    display: block;
    z-index: 1;
    content: "";
    position: absolute;
    top: 50%;
    left: 10px;
    right: 10px;
    height: 34px;
    transform: translate(0, -50%);
    border-radius: 17px;
    background: white;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
  }
  .btn-shadow {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 48px;
    height: 48px;
    line-height: 44px;
    border-radius: 24px;
    box-shadow: inset 0px 0px 4px 2px rgba(0, 0, 0, 0.1);
  }
  &.dark {
    .player-header-btn-left,
    .player-header-btn-right,
    .player-header-btn-center {
      background: #222;
    }
    &:before {
      background: #222;
    }
  }
}
</style>
